export interface GitlabPackage {
  version: string;
  created_at: string;
  name: string;
}
